import { getTaskFilterGroups } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';
export const useGetTaskFilterGroups = (userId: string) => {
  const { data, status, refetch } = useQuery(
    ['task-filter-groups', userId],
    () => getTaskFilterGroups(userId)
  );

  return {
    storedFilterGroups: data,
    storedFilterGroupsStatus: status,
    fetchStoredFilterGroups: refetch,
  };
};
